(() => {
  const protect = (form, index) => {
    if (!form || form.dataset.id7BotProtection === 'active') return;
    form.dataset.id7BotProtection = 'active';
    const started = Date.now();
    const trapWrap = document.createElement('div');
    trapWrap.className = 'id7-global-bot-trap';
    trapWrap.setAttribute('aria-hidden', 'true');
    trapWrap.innerHTML = `<label for="id7-company-site-${index}">Company website — leave empty</label><input id="id7-company-site-${index}" name="contact[company_website]" type="text" tabindex="-1" autocomplete="off">`;
    form.prepend(trapWrap);
    const stamp = document.createElement('input');
    stamp.type = 'hidden';
    stamp.name = 'contact[form_started]';
    stamp.value = String(started);
    form.prepend(stamp);
    form.addEventListener('submit', (event) => {
      const trap = trapWrap.querySelector('input');
      if ((trap && trap.value.trim()) || Date.now() - started < 2800) {
        event.preventDefault();
        let warning = form.querySelector('.id7-global-bot-warning');
        if (!warning) {
          warning = document.createElement('div');
          warning.className = 'id7-global-bot-warning';
          warning.setAttribute('role', 'alert');
          warning.tabIndex = -1;
          warning.textContent = 'We could not verify this submission. Please wait a moment and try again.';
          form.prepend(warning);
        }
        warning.focus();
        return;
      }
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }
    });
  };
  const initialise = () => document.querySelectorAll('form[action*="/contact"]').forEach(protect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
